
import React from 'react';
import './competenceTitle.css';


class CompetenceTitle extends React.Component {
  render() {
    return (
      <div className="title-body">
        <div className={`${this.props.icon} box`}></div>
        <div className={`${this.props.color} sigla title-competences`}>
          <b>
            <span className="font32 ml-2 mr-2">{this.props.sigla}</span>
            {this.props.title}
          </b>
        </div>
      </div>
    );
  }
}
export default CompetenceTitle;